import fetch from './../utils/fetch';

export function login (username, password, captcha, systemPwdLogin) {
  const data = {
    username,
    password,
    captcha,
    systemPwdLogin
  };
  return fetch({
    url: '/api/auth/jwt/token',
    method: 'post',
    data
  });
}

export function logout (token) {
  return fetch({
    url: '/api/auth/jwt/invalid',
    method: 'post',
    params: {token}
  });
}

export function getInfo (token) {
  return fetch({
    url: '/api/admin/user/front/info',
    method: 'get',
    params: { token, appType: 'SDX_LIQUIDATION_ALLINPAY' }
  });
}

// 修改密码
export function updatePassword (data) {
  return fetch({
    url: '/api/admin/supplier/password/update',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js